import axios from "axios";
import { GLOBAL_URL } from "./constants";
import { toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store from "reduxStore/store";
import { userLogout } from "reduxStore/action/authActions";
const httpClient = axios.create({
  baseURL: `${GLOBAL_URL}/api/`,
});


export function setDefaultHeader(header, value) {
  httpClient.defaults.headers.common[header] = value;
}
export async function apiCall(
  method,
  url,
  data,
  header = {
    "Content-Type": "application/json",
  }
) {
  const controller = new AbortController();
  const { response } = store.getState().login;
  // try {
  let headers = {
    ...header,
    token: response?.token,
  };
  if (!data?.isLoadMore) {
    window.document.getElementById("loaderoverlay").style.display = "block";
  }
  const result = await httpClient({
    method,
    url,
    data,
    headers: headers,
    withCredentials: false,
    signal: controller.signal,
  });
  if (result) {
    setTimeout(() => {
      window.document.getElementById("loaderoverlay").style.display = "none";
    }, 1000);
    return result;
  }
}

export const successToast = (msg) => {
  toast.success(msg, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Flip,
  });
  window.document.getElementById("loaderoverlay").style.display = "none";
};
export const errorToast = (msg) => {
  toast.error(msg, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Flip,
  });
  window.document.getElementById("loaderoverlay").style.display = "none";
};
export const unAuthorizedError = (data) => {
  toast.error(data.message, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Flip,
  });
  window.document.getElementById("loaderoverlay").style.display = "none";
  if (data.status === 401 || data.status === 400 || data.status === 403) {
    store.dispatch(userLogout());
    window.localStorage.clear();
    window.location.reload();
  }
};
export const warnToast = (msg) => {
  toast.warn(msg, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  window.document.getElementById("loaderoverlay").style.display = "none";
};
export const infoToast = (msg) => {
  toast.info(msg, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  window.document.getElementById("loaderoverlay").style.display = "none";
};

